export const knockout = '"Knockout 30 A", "Knockout 30 B", sans-serif'
